export default __webpack_public_path__ + "static/media/new-animation.ee63e703.jpg";